import { render, staticRenderFns } from "./ThreadListSort.vue?vue&type=template&id=2c5d0fcb"
import script from "./ThreadListSort.vue?vue&type=script&lang=js"
export * from "./ThreadListSort.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports